// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0455 6.72498C8.23803 1.75848 17.0961 1.75824 23.2887 6.72485L24.0678 7.34974L12.6671 21.6008L1.26636 7.34987L2.0455 6.72498Z"}}]};

const Wifi1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wifi-1-filled',
    ref,
    icon: element,
  },
));

Wifi1FilledIcon.displayName = 'Wifi1FilledIcon';

export default Wifi1FilledIcon;
